import React from "react";
import "../uiThemeConfig.css";
import { Box } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RefreshIcon from "@mui/icons-material/Refresh";
import defaultLogo from "../../../../../assets/image/png/salescode-logo.png";


interface RectangleComponentProps {
  backgroundColor: string;
  logoHeight: number;
  logo: string;
}

function RectangleComponent(props: RectangleComponentProps) {
  return (
    <Box
      width={"100%"}
      height={"80%"}
      border="1px solid #227C9D"
      borderRadius="4px"
      marginRight="10px"
      maxHeight="auto"
      padding="10px"
      alignItems="center"
      justifyContent="center"
    >
      <div
        className="screen-container"
        style={{ backgroundColor: props.backgroundColor }}
      >
        <img
          src={
            props.logo !== ""
              ? props.logo
              : defaultLogo
          }
          alt="Logo"
          style={{ height: props.logoHeight,maxHeight:"40px" }}
        />

        <div className="icon-container-ui-theme">
          <Box>
            <NotificationsIcon
              className="icon"
              sx={{ color: "#ffffff" }}
            />
          </Box>
          <Box sx={{width:"10px"}}></Box>
          <Box>
            <RefreshIcon
              className="icon"
              sx={{ color: "#ffffff" }}
            />
          </Box>
        </div>
      </div>
    </Box>
  );
}

export default RectangleComponent;
